<template>
  <div class="step6">
    <p class="text1">店頭受取予約が完了しました</p>
    <p class="text2">
      ご予約ありがとうございます。<br />店頭受取のご予約が完了いたしました。<br />ご予約内容のご変更はお電話のみの対応となります。ご了承ください。<br />また、WEBご予約日当日へのお受取変更は、承っておりません。当日は受取時間を過ぎ、閉店1時間前までにご連絡のない場合は、ご予約はキャンセルとさせていただきます。<br />
      またスマートショップの場合、決済完了後の変更キャンセルは承っておりません。ご了承くださいませ。
    </p>
    <p class="text-center">
      <small> ※ご予約内容のご変更はお電話のみの対応となります。ご了承ください。 </small>
    </p>
    <router-link to="/" class="btn a">トップページへ戻る<i class="fas fa-chevron-right"></i></router-link>
  </div>
</template>

<script>
export default {
  name: 'step6',
  props: ['buttonText', 'step', 'shops', 'radioResult', 'weeks', 'calData', 'reservation'],
  mounted() {
    let modalCartBtn = document.getElementById('pageHeaderCartBtn')
    modalCartBtn.style.display = 'none'
  },
  methods: {
    prev: function (number) {
      this.$emit('prev', number)
    }
  }
}
</script>

<style scoped lang="scss">
.step6 {
}
.btn {
  text-align: center;
  display: block;
  margin: 30px auto 0;
  padding: 15px 0;
  background-color: #831f17;
  color: #fff;
  width: 80%;
  position: relative;
  &:hover {
    opacity: 0.7;
    cursor: pointer;
  }
  i {
    margin-left: 15px;
  }
}
.text1 {
  font-size: 18px;
  font-weight: 530;
  line-height: 1.28;
  text-align: center;
  color: #333333;
}
.text2 {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.64;
  text-align: center;
  color: #333333;
}
</style>
